import EyeHidden from 'apollo-react-icons/EyeHidden';
import EyeShow from 'apollo-react-icons/EyeShow';
import React, { Component } from 'react';

import InputField from './InputField';
import InputIcon from './InputIcon';

class PasswordInput extends Component {
  state = {
    passwordIsMasked: true,
  };

  togglePasswordMask = () => {
    this.setState((prevState) => ({
      passwordIsMasked: !prevState.passwordIsMasked,
    }));
  };

  render() {
    const { handleChange, handleBlur, label, error, ...props } = this.props;
    const { passwordIsMasked } = this.state;
    return (
      <InputField
        {...props}
        error={error}
        type={passwordIsMasked ? 'password' : 'text'}
        onChange={handleChange || null}
        onBlur={handleBlur || null}
        label={label}
        InputProps={{
          endAdornment: (
            <InputIcon position="end">
              {passwordIsMasked ? (
                <EyeShow onClick={this.togglePasswordMask} />
              ) : (
                <EyeHidden onClick={this.togglePasswordMask} />
              )}
            </InputIcon>
          ),
          inputProps: { autoComplete: 'off' },
        }}
      />
    );
  }
}

export default PasswordInput;
